import { VerifyCodeResponseBodySuccess } from './types';

export function isVerifyCodeResponseBodySuccess(x: unknown): x is VerifyCodeResponseBodySuccess {
  return typeof x === 'object'
    && x !== null
    && 'data' in x
    && isVerifyCodeResponseData(x.data);
}

function isVerifyCodeResponseData(x: unknown): x is VerifyCodeResponseBodySuccess['data'] {
  return typeof x === 'object'
    && x !== null
    && 'type' in x
    && typeof x.type === 'string'
    && 'id' in x
    && typeof x.id === 'string'
    && 'attributes' in x
    && isVerifyCodeResponseAttributes(x.attributes);
}

function isVerifyCodeResponseAttributes(x: unknown): x is VerifyCodeResponseBodySuccess['data']['attributes'] {
  return typeof x === 'object'
    && x !== null
    && 'token' in x
    && typeof x.token === 'string'
    && 'ttl' in x
    && typeof x.ttl === 'number';
}
